if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.targetButton = document.getElementById(this.dataset.targetButton);
        this.button = this.querySelector('.sticky-buy-bar__button');
        if (!this.targetButton || !this.button) return;

        this.button.addEventListener('click', this.handleClick.bind(this));

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0 });
        this.observer.observe(this.targetButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      handleClick() {
        if (this.targetButton.disabled || this.targetButton.getAttribute('aria-disabled') === 'true') return;
        this.targetButton.click();
      }

      handleIntersect(entries) {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-buy-bar--visible', scrolledPast);
        // Shopify Inbox's chat bubble is also fixed to the bottom-right and doesn't
        // know this bar exists, so it sits on top of the add-to-cart button.
        document.body.classList.toggle('sticky-buy-bar-active', scrolledPast);
      }
    }
  );
}
